export function setGalleryOpen(data, url= null) {
  if(!data){
    return {
      type: 'SET_GALLERY_OPEN',
      payload: data
    }
  }

  return {
    type: 'SET_GALLERY_OPEN',
    payload: {data, url},
  }
}
